import Layout from 'components/shared/Layout'
import ResourceNavigation from 'components/shared/ResourceNavigation'
import SliceManager from 'components/shared/SliceManager'
import delve from 'dlv'
import React from 'react'
import { getDataDependencies } from 'services/api'
import fetchSingleType from 'src/lib/Strapi/fetchSingleType'

import ResourceCenterSearch from 'src/components/shared/search/SearchBar'
import PreviewBanner from 'components/shared/PreviewBanner'

import css from './styles.module.scss'

const ResourceCenter = ({ pageData, preview }) => {
  const navigation = delve(pageData, 'navigation')
  const slices = delve(pageData, 'slices')

  const indices = [
    {
      label: 'Plugins',
      name: 'plugins',
    },
    {
      label: 'Providers',
      name: 'providers',
    },
    {
      label: 'Dev docs & User Docs',
      name: 'documentation',
    },
    {
      label: 'Blog Posts',
      name: 'blog_posts',
    },
    {
      label: 'Integrations',
      name: 'integrations',
    },
    {
      label: 'Partners',
      name: 'partners',
    },
  ]

  return (
    <section className={css.ResourceCenter}>
      {preview && <PreviewBanner />}
      <ResourceCenterSearch indices={indices} />
      <Layout type="wrapper" className={css.ResourceWrapper}>
        <div className={css.Resources}>
          {navigation && (
            <ResourceNavigation
              className={css.resourceNavigation}
              {...navigation}
            />
          )}
          {slices && (
            <SliceManager
              className={css.resourceCenterWrapper}
              slices={slices}
            />
          )}
        </div>
      </Layout>
    </section>
  )
}

export async function getStaticProps({ preview = null }) {
  const data = (await fetchSingleType('resource-center', preview)) || {}
  const pageData = await getDataDependencies(data)

  return {
    props: {
      pageData,
      preview,
    },
  }
}

export default ResourceCenter
